module.exports = __webpack_public_path__ + "img/1_1-piazza-2-fontana.1697aa89.png";